<template>
    <div v-show="chatEntryInput.attachments.length > 0" class="active-team-chat-asset-preview">
        <div class="asset-flex-box">
            <div v-for="asset in chatEntryInput.attachments" :key="asset.fileName" class="asset">
                <b-button
                    variant="flat-secondary"
                    class="rounded-circle p-0 asset-unlink-button bg-white"
                    @click="unlinkAsset(asset)"
                >
                    <font-awesome-icon icon="times" size="sm" />
                </b-button>
                <div v-if="!asset.isUploadingFilePending" class="asset-previev-content">
                    <div
                        v-if="asset.contentType.match('image.*')"
                        :key="asset.fileName"
                        :style="{ 'background-image': `url(${getSrc(asset.originalFileObject)})` }"
                        class="asset-image"
                    />
                    <div v-else class="asset-icon">
                        <font-awesome-icon size="3x" :icon="resolveContentTypeIcon(asset.contentType)" />
                    </div>
                </div>

                <b-spinner v-else :label="$t('loading')" variant="primary" class="m-1" />
            </div>
        </div>
    </div>
</template>

<script>
import { BContainer, BRow, BCol, BImg, BButton, BSpinner } from "bootstrap-vue";
import { resolveContentTypeIcon } from "@/utils/chats";
import useActiveTeamChat from "@/views/modules/team-chat/useActiveTeamChat";

export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BImg,
        BButton,
        BSpinner,
    },
    methods: {
        getSrc(file) {
            return URL.createObjectURL(file);
        },
        unlinkAsset(asset) {
            // this.file is the original upload object.
            const originalFileObjectIndex = this.fileUploads.findIndex(
                (fileAsset) => fileAsset === asset.originalFileObject
            );
            this.fileUploads.splice(originalFileObjectIndex, 1);

            const fileIndex = this.chatEntryInput.attachments.findIndex((fileAsset) => fileAsset === asset);
            this.chatEntryInput.attachments.splice(fileIndex, 1);
        },
    },
    setup() {
        const { fileUploads, chatEntryInput } = useActiveTeamChat();

        return {
            resolveContentTypeIcon,
            fileUploads,
            chatEntryInput,
        };
    },
};
</script>
